import {
  Plugin,
  PluginListenerHandle,
  registerPlugin,
} from '@capacitor/core';
import { NutakuGi2SigninData } from '../types/nutaku-gi2.interface';

export interface NutakuGi2NativePaymentRequest {
  price: number;
  skuId: string;
  name: string;
  imgUrl: string;
  description: string;
  message: string;
}

export interface NutakuGi2NativePaymentResponse {
  status: 'success' | 'cancel' | 'error' | 'errorFromGPHS';
  paymentId?: string;
  error?: string;
}

export interface NutakuGi2Plugin extends Plugin {
  authenticate(): Promise<NutakuGi2SigninData>;
  createPayment(
    request: NutakuGi2NativePaymentRequest,
  ): Promise<NutakuGi2NativePaymentResponse>;
  sendHeartbeat(): Promise<void>;
  addListener(
    eventName: 'auth',
    listenerFunc: (event: { isOk: boolean; data?: NutakuGi2SigninData; error?: string }) => void,
  ): Promise<PluginListenerHandle>;
  addListener(
    eventName: 'payment',
    listenerFunc: (event: NutakuGi2NativePaymentResponse) => void,
  ): Promise<PluginListenerHandle>;
}

export const NutakuGi2 = registerPlugin<NutakuGi2Plugin>('NutakuGi2');
